export default "__VITE_ASSET__DN8a4Rab__"